"use client";

import type { ReactNode } from "react";

/**
 * The two-up selected/unselected option control shared by every widget
 * customizer (language, theme). It existed as four byte-identical inline
 * button elements in each of the three customizers; one owner keeps their
 * appearance from drifting apart and keeps each customizer's render body
 * inside the max-lines budget.
 *
 * (The element name is spelled out rather than written as a JSX tag on purpose:
 * the design-adoption detector regex-scans source text and cannot tell a tag in
 * a comment from a real one, so a literal tag here reads as a typeless button.)
 *
 * Markup and class strings are unchanged from the inline original.
 */
export function WidgetOptionButton({
  active,
  onClick,
  children,
}: {
  active: boolean;
  onClick: () => void;
  children: ReactNode;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`rounded-lg border px-3 py-2 text-center font-medium transition-colors ${
        active
          ? "border-brand-primary bg-brand-primary/10 text-intent-brand font-semibold"
          : "border-border-default bg-surface-canvas text-text-muted hover:border-border-subtle"
      }`}
    >
      {children}
    </button>
  );
}
